import { render } from "./AdditionalPrepInfo.vue?vue&type=template&id=2c22d76d"
import script from "./AdditionalPrepInfo.ts?vue&type=script&lang=js&external"
export * from "./AdditionalPrepInfo.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__